import React from "react";
import styled from "styled-components";

const Container = styled.div`
  background: linear-gradient(180deg, var(--ice-blue), var(--surface-white));
  height: 100vh;
  width: 100%;
  position: fixed;
  z-index: -900;
  overflow: hidden;
`;

const Shape = styled.div`
  position: absolute;
  border-radius: 999px;
  filter: blur(0.5px);
`;

const LeftBubble = styled(Shape)`
  width: 360px;
  height: 360px;
  left: -90px;
  bottom: -140px;
  background: radial-gradient(circle at 35% 35%, rgba(59, 99, 247, 0.22), rgba(59, 99, 247, 0));
`;

const RightBubble = styled(Shape)`
  width: 380px;
  height: 380px;
  right: -120px;
  bottom: -120px;
  background: radial-gradient(circle at 40% 40%, rgba(46, 196, 182, 0.2), rgba(46, 196, 182, 0));
`;

const AccentBubble = styled(Shape)`
  width: 260px;
  height: 260px;
  right: 22%;
  top: -120px;
  background: radial-gradient(circle at 45% 45%, rgba(247, 111, 111, 0.14), rgba(247, 111, 111, 0));
`;

const Background = () => {
  return (
    <Container>
      <LeftBubble />
      <RightBubble />
      <AccentBubble />
    </Container>
  );
};

export default Background;
